module.exports = __webpack_public_path__ + "static/erickson2thumb-e367d1916497f5d3605492e64233ccda.jpg";